// PerformanceDetails.js
import { useState } from "react";
import ToolTip from "@/components/ui/tooltip/ToolTip";

import DetailsComponent from "@/components/ui/cards/DetailsComponent";
import styles from "@/components/ev-details/PerformanceDetails.module.css";

const PerformanceDetails = ({ data }) => {
  const [showAdvanced, setShowAdvanced] = useState(false); // internal state for showing advanced data

  const handleToggle = (newState) => {
    setShowAdvanced(newState);
  };

  const sortedData = data.sort((a, b) => a.cw_position - b.cw_position);

  const parseValue = (value, unit) => {
    if (unit && unit !== "null") {
      return (
        <>
          <span className={styles.detailValue}>{value}</span>
          <span className={styles.detailUnit}>{` ${unit}`}</span>
        </>
      );
    } else if (value.includes(" ")) {
      // If unit is null or "null", and value contains spaces, split the value into segments
      const segments = value.split(" ");
      return segments.map((segment, index) => {
        // If even index, it's a value; if odd index, it's a unit
        const isValue = index % 2 === 0;
        return (
          <span
            key={index}
            className={isValue ? styles.detailValue : styles.detailUnit2}>
            {segment}
          </span>
        );
      });
    } else {
      return <span className={styles.detailValue}>{value}</span>;
    }
  };

  return (
    <DetailsComponent
      title="Performance"
      showToggle={true}
      onToggle={handleToggle}>
      <div className={styles.detailBox}>
        {sortedData.map((detail, index) => {
          if (detail.advanced && !showAdvanced) {
            return null; // don't render advanced details unless showAdvanced is true
          }

          return (
            <div key={index} className={styles.detail}>
              {parseValue(detail.value, detail.unit)}
              <div className={styles.icon}>{detail.icon}</div>
              <div className={styles.detailLabel}>{detail.label}</div>
              {detail.description && (
                <ToolTip tooltipText={detail.description}>
                  <span>?</span>
                </ToolTip>
              )}
            </div>
          );
        })}
      </div>
    </DetailsComponent>
  );
};

export default PerformanceDetails;
